import Image from "./Image";
import PropTypes from "prop-types";

export default function ImageBlock({
  value: { width, height, title, src, srcSet },
}) {
  return (
    <Image
      src={src}
      srcSet={srcSet}
      sizes="100vw"
      alt={title}
      width={width}
      height={width * (height / width)}
      fadeInOnLoad
      backgroundColor="var(--off-light)"
    />
  );
}

ImageBlock.propTypes = {
  value: PropTypes.shape({
    src: PropTypes.string.isRequired,
    srcSet: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }),
};
